import { Input } from '@trackman/web-shared-components';

type Props = {
  lessonContent: string;
  handleLessonContent: (lessonContent: string) => void;
};

export const VideoLessonField = ({ lessonContent, handleLessonContent }: Props) => {
  return (
    <Input
      label='Youtube Video ID'
      value={lessonContent}
      required
      onChange={(e) => handleLessonContent(e.currentTarget.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    />
  );
};
